<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header
      class="text-[1rem]"
      label="API-Logs">
      <ng-template nxTemplate="end">
        <input
          pInputText
          type="text"
          (input)="httpLogTable.filter($event.target?.['value'], 'statusCode', 'contains')"
          class="p-inputtext p-component p-element mr-3"
          placeholder="Suche Status" />
        <input
          pInputText
          (input)="httpLogTable.filterGlobal($event.target?.['value'], 'contains')"
          type="text"
          class="p-inputtext p-component p-element mr-3"
          placeholder="Suche Text" />
        <nx-default-button
          (click)="refetchHttpLogs()"
          [style]="'light'"
          [label]="'Aktualisieren'"
          [icon]="'icon-refresh'">
        </nx-default-button>
      </ng-template>
    </nx-table-header>
    <p-table
      #httpLogTable
      [lazy]="true"
      (onLazyLoad)="loadData($event)"
      [value]="dataSource?.data"
      [scrollable]="true"
      [paginator]="true"
      [rows]="15"
      selectionMode="single" 
      [(selection)]=dataSource.selectedHttpLogEntry 
      [rowsPerPageOptions]="[15, 20, 50]"
      [totalRecords]="dataSource?.totalElements"
      [loading]="loading"
      [sortField]="sortProperty" 
      [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} von {totalRecords}"
      [resizableColumns]="true">
      <ng-template pTemplate="caption">
        <div class="flex flex-row">
          <div class="basis-2/3 flex flex-row gap-2">
            <!-- no filter -->
          </div>
          <div class="basis-1/3 flex flex-row justify-end">
            <p-dropdown
              placeholder="Sortierung"
              [styleClass]="'sort'"
              appendTo="body"
              [ngModel] = "sortModel"
              [options]="sortOptions"
              optionLabel="label"
              [showClear]="false"
              (onChange)="sort($event)">
            </p-dropdown>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr >
            <th style="min-width: 5rem; width: 5rem;">Status</th>
            <th style="min-width: 5rem; width: 5rem;">Method</th>
            <th style="width: auto;">Path</th>
            <th style="min-width:9.813rem; width: 9.813rem;">Start</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-httpLog>
        <tr class="clickable" [pSelectableRow]="httpLog">
          <td>
            <p-tag 
              [value]="httpLog.statusCode"
              [severity]="calculateSeverity(httpLog.statusCode)">
            </p-tag>
          </td>
          <td>{{httpLog.method}}</td>
          <td>{{httpLog.path}}</td>
          <td>{{httpLog.startDateTime | date:'dd.MM. HH:mm:ss'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">Keine Logs gefunden.</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
    </ng-template>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      [label]="dataSource?.selectedHttpLogEntry?.path ? (dataSource?.selectedHttpLogEntry?.method + ' ' + dataSource?.selectedHttpLogEntry?.path) : '-'">
    </nx-headline-box>
    <nx-default-box
    class="bg-white border-b border-gray"
    [label]="'ID'">
      {{dataSource?.selectedHttpLogEntry?.id}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedHttpLogEntry?.id"
          (click)="copyToClipboard(dataSource?.selectedHttpLogEntry?.id)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Status'">
      {{dataSource?.selectedHttpLogEntry?.statusCode}} {{dataSource?.selectedHttpLogEntry?.statusPhrase}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Start'">
      {{dataSource?.selectedHttpLogEntry?.startDateTime | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'API-Key ID'">
      {{dataSource?.selectedHttpLogEntry?.apiKeyId}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedHttpLogEntry?.apiKeyId"
          (click)="copyToClipboard(dataSource?.selectedHttpLogEntry?.apiKeyId)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Trace ID'">
      {{dataSource?.selectedHttpLogEntry?.traceId}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedHttpLogEntry?.traceId"
          (click)="copyToClipboard(dataSource?.selectedHttpLogEntry?.traceId)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Transaction ID'">
      {{dataSource?.selectedHttpLogEntry?.transactionId}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedHttpLogEntry?.transactionId"
          (click)="copyToClipboard(dataSource?.selectedHttpLogEntry?.transactionId)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Request ID'">
      {{dataSource?.selectedHttpLogEntry?.requestId}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedHttpLogEntry?.requestId"
          (click)="copyToClipboard(dataSource?.selectedHttpLogEntry?.requestId)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    
    <nx-headline-box
      class="mt-2"
      [label]="'Request Body'">
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedHttpLogEntry?.requestBody"
          [style]="'light'"
          [icon]="'icon-copy'"
          (click)="copyRequestContent(this.dataSource?.selectedHttpLogEntry?.requestBody)"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-headline-box>
    <div class="py-2 bg-white">
      <nx-empty-box
        *ngIf="!this.dataSource?.selectedHttpLogEntry?.requestBody"
        [label]="'RequestBody is leer.'">
      </nx-empty-box>
      <ng-container *ngIf="this.dataSource?.selectedHttpLogEntry?.requestBody && isJsonString(this.dataSource?.selectedHttpLogEntry?.requestBody)">
        <ace [config]="editorConfig" [mode]="'json'" id="editor1" [disabled]="true" [theme]="'github'" [value]="getCodeModel(this.dataSource?.selectedHttpLogEntry?.requestBody)"></ace>
      </ng-container>
      <ng-container *ngIf="this.dataSource?.selectedHttpLogEntry?.requestBody && !isJsonString(this.dataSource?.selectedHttpLogEntry?.requestBody)">
        <ace [config]="editorConfig" [mode]="'text'" id="editor1" [disabled]="true" [theme]="'github'" [value]="getString(this.dataSource?.selectedHttpLogEntry?.requestBody)"></ace>
      </ng-container>
    </div>

    <nx-headline-box
      class="mt-2"
      [label]="'Response Body'">
      <ng-template nxTemplate="end">
        <nx-default-button
        [disabled]="!this.dataSource?.selectedHttpLogEntry?.responseBody"
          (click)="copyRequestContent(this.dataSource?.selectedHttpLogEntry?.responseBody)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-headline-box>
    <div class="py-2 bg-white">
      <nx-empty-box
        *ngIf="!this.dataSource?.selectedHttpLogEntry?.responseBody"
        [label]="'ResponseBody is leer.'">
      </nx-empty-box>
      <ng-container *ngIf="this.dataSource?.selectedHttpLogEntry?.responseBody">
        <ace [config]="editorConfig" [mode]="'json'" id="editor2"  [disabled]="true"   [theme]="'github'" [value]="getCodeModel(this.dataSource?.selectedHttpLogEntry?.responseBody)" [ngStyle]="{'height':'calc(100% - 300px)'}"></ace>
      </ng-container>
    </div>

  </div>
</div>